import { ApiActions } from '../../../constants/ApiActions';

export enum Actions {
  AD_CREATED = 'AD_CREATED',
  AD_DESTROYED = 'AD_DESTROYED',
  AD_ENDED = 'AD_ENDED',
  AD_MANAGER_EVENT = 'AD_MANAGER_EVENT',
  AD_REQUEST_ATTEMPT = 'AD_REQUEST_ATTEMPT',
  AD_REQUEST_FAIL = 'AD_REQUEST_FAIL',
  AD_REQUEST_SUCCESS = 'AD_REQUEST_SUCCESS',
  AD_SKIPPED = 'AD_SKIPPED',
  AD_STARTED = 'AD_STARTED',
  DEQUEUE_ADS = 'DEQUEUE_ADS',
  ENQUEUE_ADS = 'ENQUEUE_ADS',
  INCREMENT_INDEX = 'INCREMENT_INDEX',
  SKIP_AD = 'SKIP_AD',
  /**
   * Hide video player
   */
  HIDE_VIDEO_AD = 'HIDE_VIDEO_AD',
  /**
   * Video ad init
   */
  INIT_VIDEO_AD = 'INIT_VIDEO_AD',
  /* #region Video Ads */
  /**
   * Load video asset into state
   */
  LOAD_VIDEO_AD = 'LOAD_VIDEO_AD',

  RECEIVING_VMAP = 'RECEIVING_VMAP',
  RESUME_PLAYBACK_AFTER_ADS = 'RESUME_PLAYBACK_AFTER_ADS',
  /**
   * Show video player
   */
  SHOW_VIDEO_AD = 'SHOW_VIDEO_AD',
  /**
   * Unload video asset from state
   */
  UNLOAD_VIDEO_AD = 'UNLOAD_VIDEO_AD',
  VMAP_AD_OPPORTUNITY = 'VMAP_AD_OPPORTUNITY',
  /* #endregion */
}

export const ApiActionsWithVmap = [
  // ApiActions.ACTION_REPLAY_SUCCESS,
  // ApiActions.PLAYBACK_ITEM_SUCCESS,
  // ApiActions.PLAYBACK_ITEM_LIST_SUCCESS,
  // ApiActions.PLAYBACK_MIDROLL_SUCCESS,
  ApiActions.ACTION_MODE_SUCCESS,
  ApiActions.ACTION_SKIP_SUCCESS,
  ApiActions.PLAYBACK_CURRENT_SUCCESS,
  ApiActions.PLAYBACK_PEEK_SUCCESS,
  ApiActions.PLAYBACK_SOURCE_SUCCESS,
] as const;

export enum CompanionActions {
  COMPANION_CLICKED = 'COMPANION_CLICKED',
  COMPANION_LOADED = 'COMPANION_LOADED',
  TILE_LOADED = 'TILE_LOADED',
}

export enum AdTypes {
  AUDIO_AD = 'AUDIO_AD',
  REWARD_AD = 'REWARD_AD',
  VIDEO_AD = 'VIDEO_AD',
}

export enum AdEncodingTypes {
  MP3 = 'mp3',
  MP4 = 'mp4',
}

export enum AdBreakTypes {
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
}

export enum SUBZONES {
  NOWPLAYING = 'nowplaying',
  BACKSTAGE = 'backstage',
  TUNER = 'tuner',
}
